<template>
  <div class="bg">
    <div class="title-container">
      <div class="title">
        <!-- <img src="../../assets/Starting/img-hotspot/logo.png" /> -->
        热点分析-酒泉
      </div>
    </div>
    <div class="main">
      <div class="info">
        <div class="hotspot-title">{{ this.topic_name }}</div>
        <div class="brief-introduction">{{ this.topic_info }}</div>
      </div>
      <div class="main_chart">
        <div class="left">
          <span class="left-title">网民代表观点</span>
          <div class="header">
            <div class="point">观点</div>
            <div class="comment">相似评论数</div>
          </div>
          <div class="info-body">
            <div v-if="this.list_data.length==0">
              <div class="c1">暂无评论</div>
            </div>
            <div v-if="this.list_data.length<=6">
              <div
                class="info-item"
                v-for="(item, index) in list_data"
                :key="index"
                @click="geList(item)"
              >
                <div v-if="item.comment" class="t1">{{ item.comment }}</div>
                <!-- <div v-if="item.comment" class="t3" >{{ item.local }}</div> -->
                <div v-if="item.view" class="t1">{{ item.view }}</div>
                <div v-if="item.count" class="t2">{{ item.count }}</div>
                <div v-if="item.content_id" class="t2">-</div>
              </div>
            </div>

            <vue-seamless-scroll
              v-if="this.list_data.length>6"
              :data="list_data"
              class="seamless-warp"
              :class-option="defaultOption"
            >
              <div
                class="info-item"
                v-for="(item, index) in list_data"
                :key="index"
                @click="geList(item)"
              >
                <div v-if="item.comment" class="t1">{{ item.comment }}</div>
                <!-- <div v-if="item.comment" class="t3" >{{ item.local }}</div> -->
                <div v-if="item.view" class="t1">{{ item.view }}</div>
                <div v-if="item.count" class="t2">{{ item.count }}</div>
                <div v-if="item.content_id" class="t2">-</div>
              </div>
            </vue-seamless-scroll>
          </div>
        </div>
        <div class="right">
          <span class="right-title">情绪分析</span>
          <div id="echart">
            <my-pie :Emotion="Emotion"></my-pie>
          </div>
          <div class="hot-words">
            <div class="positive">
              <worcloudPositive :POSITIVE="POSITIVE"></worcloudPositive>
            </div>
            <div class="negative">
              <worcloudNegative :NEGATIVE="NEGATIVE"></worcloudNegative>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
      <div class="body_tiele">
        {{ this.list.view }}
        <img
          class="body_img"
          @click="goind(list.url)"
          src="@/assets/lian.png"
          alt
        />
      </div>
      <!-- <div class="live">{{this.list.source}}<div>{{this.list.date}}</div></div>
      <div  class="body_cont">{{this.list.content}}</div>-->
      <span slot="footer" class="dialog-footer"></span>
    </el-dialog>
  </div>
</template>

<script>
import vueSeamlessScroll from "vue-seamless-scroll";
import myClass from "../../components/echart/hotspot/myClass.vue";
import pieFour from "../../components/echart/hotspot/pieFour.vue";
import { viewpoint, gethotSpotAnalysis3 } from "../../api/bot";
import worcloudPositive from "../../components/echart/hotspot/echarts-worcloud/worcloudPositive.vue";
import worcloudNegative from "../../components/echart/hotspot/echarts-worcloud/worcloudNegative.vue";
export default {
  name: "index",
  name: "VueWordCloud",
  components: {
    vueSeamlessScroll
  },
  data() {
    return {
      text: "疫情防控",
      searchRang: "title",
      classify: "1",
      type: "2",
      topic_name: "疫情防控",
      dialogVisible: false,
      topic_info:
        "据首发集团消息，数字人民币业务应用服务场景将再增加，用于北京市高速公路与停车支付上，为市民出行提供便利",
      list_data: [],
      list_data1: [],
      list_data2: [],
      list: {},
      //组件之间
      Emotion: [], //情感分析
      POSITIVE: [], //正面关键词
      NEGATIVE: [], //反面关键词

      classOption: {
        step: 0.5,
        limitMoveNum: 9,
        openTouch: false
      }
    };
  },
  components: {
    "my-class": myClass,
    "my-pie": pieFour,
    worcloudPositive,
    worcloudNegative
  },
  created() {
    this.topic_name = window.localStorage.getItem("JiuQuan_name");
    this.topic_info = window.localStorage.getItem("JiuQuan_info");
    this.load(); // 网民代表观点数据
    this.daxian(); //echarts图数据获取
    setInterval(() => {
      this.topic_name = window.localStorage.getItem("JiuQuan_name");
      this.topic_info = window.localStorage.getItem("JiuQuan_info");
    }, 50);
  },
  watch: {
    topic_name() {
      this.load();
      this.daxian(); //echarts图数据获取
    }
  },
  computed: {
    // 监听属性 类似于data概念
    defaultOption() {
      return {
        step: 0.5, // 数值越大速度滚动越快
        limitMoveNum: 1, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
      };
    }
  },
  methods: {
    daxian() {
      gethotSpotAnalysis3({
        text: this.topic_name
      }).then(res => {
        this.Emotion = res.data.data[2];
        this.POSITIVE = res.data.data[0].POSITIVE;
        this.NEGATIVE = res.data.data[1].NEGATIVE;
      });
    },
    geList(item) {
      // this.dialogVisible = true;
      this.list = item;
    },
    handleClose(done) {
      this.dialogVisible = false;
    },
    load() {
      viewpoint({
        text: this.topic_name,
        type: this.type,
        classify: this.classify,
        searchRang: this.searchRang
      }).then(res => {
        this.list_data1 = res.data.data[0];
        this.list_data2 = res.data.data[1];
        if (this.list_data1.length == 0) {
          this.list_data = this.list_data2;
        } else if (this.list_data2.length == 0) {
          this.list_data = this.list_data1;
        } else {
          this.list_data = this.list_data2.concat(this.list_data1);
        }
      });
    },
    goind(url) {
      window.open(url);
    }
  }
};
</script>

<style lang="scss" scoped>
.body_tiele {
  font-size: 30px;
  font-family: PingFang;
  font-weight: bold;
  color: #ffffff;
  line-height: 36px;
  text-align: center;
}
.body_img {
  position: relative;
  left: 5px;
  cursor: pointer;
}
.live {
  width: 50%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 60px;
  margin: 0 auto;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #60d6dd;
}
.body_cont {
  width: 90%;
  height: 60vh;
  overflow-y: scroll;
  margin: 0 auto;
  font-size: 22px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 28px;
  color: #ffffff;
}
.bg {
  width: 100vw;
  height: 100vh;
  background: url("../../assets/Starting/img-hotspot/wnmq.png");
  background-size: 100% 100%;
  overflow: hidden;
  .title-container {
    height: 11vh;
    .title {
      color: #fff;
      font-weight: bold;
      font-size: 2vw;
      line-height: 11vh;
      width: 19%;
      margin-left: 2.3%;
      overflow: hidden;
      text-align: center;
      text-overflow: ellipsis;
      white-space: nowrap;
      img {
        vertical-align: middle;
        width: 13%;
        height: 5.2vh;
        margin-right: 3.2%;
      }
    }
  }
  /** 主体部分 **/
  .main {
    height: 85vh;
    width: 90vw;
    margin-left: 5vw;
    .info {
      width: 90vw;
      height: 9vh;
      position: relative;
      top: -1.5vh;
      .hotspot-title {
        text-align: center;
        font-size: 30px;
        font-family: Adobe Heiti Std;
        font-weight: normal;
        color: #ffffff;
        line-height: 30px;
        height: 30px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .brief-introduction {
        width: 75%;
        margin: 0 auto;
        text-align: center;
        font-size: 13px;
        font-family: Myriad Pro;
        font-weight: 400;
        color: #cccccc;
        line-height: 16px;
        opacity: 0.7;
        margin-top: 0.5vh;
        height: 33px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
    }
    .main_chart {
      width: 90vw;
      height: 75vh;
      display: flex;
      .left {
        height: 75vh;
        width: 29vw;
        background-image: url("../../assets/Starting/img-hotspot/left.png");
        background-size: 100% 100%;
        margin-right: 1vw;
        .left-title {
          position: relative;
          width: 119px;
          height: 20px;
          font-size: 1rem;
          font-family: PingFang SC;
          font-weight: 500;
          color: #ffffff;
          line-height: 0.6vh;
          opacity: 0.9;
          top: 1vh;
          left: 1vw;
        }
        .header {
          width: 29vw;
          height: 2vh;
          position: relative;
          left: 2vw;
          top: 4vh;
          display: flex;
          .point {
            width: 20.8vw;
            height: 20px;
            font-size: 20px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #ffffff;
            line-height: 20px;
          }
          .comment {
            width: 6vw;
            height: 20px;
            font-size: 20px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #ffffff;
            line-height: 20px;
          }
        }

        .info-body {
          width: 28.5vw;
          height: 63vh;
          margin-top: 60px;
          overflow: hidden;
          .c1 {
            width: 100%;
            height: 100px;
            text-align: center;
            font-size: 18px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #ffffff;
          }
          .info-item {
            background: rgba(0, 0, 0, 0.2);
            height: 8.5vh;
            line-height: 7vh;
            position: relative;
            margin-bottom: 5px;
            margin-left: 10px;
            display: flex;
            justify-content: space-between;
            .t1 {
              width: 60%;
              height: 68px;
              font-size: 18px;
              font-family: PingFang SC;
              font-weight: 500;
              color: #ffffff;
              line-height: 33px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              margin-top: 5px;
              margin-left: 10px;
            }

            .t2 {
              width: 20%;
              height: 68px;
              line-height: 28px;
              font-size: 18px;
              font-family: PingFang SC;
              font-weight: 500;
              color: #ffffff;
              line-height: 24px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              margin-top: 30px;
              text-align: center;
            }
          }
        }
      }
      .right {
        height: 75vh;
        width: 60vw;
        background-image: url("../../assets/Starting/img-hotspot/right2.png");
        background-size: 100% 100%;
        .right-title {
          position: relative;
          width: 79px;
          height: 20px;
          font-size: 20px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #ffffff;
          line-height: 20px;
          opacity: 0.9;
          left: 2vw;
          top: 1vh;
        }
        #echart {
          width: 60vw;
          height: 40vh;
          margin-top: 5vh;
          margin-left: 10vw;
        }
        .hot-words {
          width: 60vw;
          height: 28vh;
          display: flex;
          .positive {
            width: 30vw;
            height: 28vh;
            margin-left: 1vw;
          }
          .negative {
            width: 30vw;
            height: 28vh;
          }
        }
      }
    }
  }
}
</style>
